import axios from 'axios';

export default function bindSaveEvent(result) {
  const { listingId } = result.dataset;
  const saveButton = result.querySelector('[data-save-status]');
  if (!saveButton) {
    return false;
  }
  const { saveStatus } = saveButton.dataset;
  if (saveStatus == 'logged-out') {
    return saveButton.addEventListener('click', function(event) {
      event.stopPropagation();
      event.preventDefault();
      loggedOutSaveButton(saveButton, listingId);
    });
  }
  return saveButton.addEventListener('click', function(event) {
    event.stopPropagation();
    event.preventDefault();
    const button = this;
    const { goToStatusPage } = button.dataset;
    if (goToStatusPage == "1") {
      goToShortlistPage(button);    
    } else {
      saveListing(button, listingId);
    }
  });
}

function goToShortlistPage(button) {
  const { href } = button.dataset;
  return window.location.assign(href);
}


function saveListing(button, listingId) {
  const { href } = button.dataset;
  const impression = _sr.ecommerce.impressions.find(
    (listing) => listing.id == listingId,
  );
  const labelString = `${impression.id}|${
    impression.brand == 'featured' ? 'f' : impression.position
  }`;
  axios.get(`${href}&format=json`).then((data) => {
    if (data.data.response_type == 'success') {
      if (data.data.result == 'added') {
        listingSaved(getDuplicateAdButton(button, listingId));
        // fire ga added event
        window.dataLayer.push({
          ga_event_category: 'narrow',
          ga_event_action: 'saved_ads_add',
          ga_event_label: labelString,
          event: 'ga.event',
        });
        return listingSaved(button);
      }
      if (data.data.result == 'removed') {
        listingRemoved(getDuplicateAdButton(button, listingId));
        // fire ga removed event
        window.dataLayer.push({
          ga_event_category: 'narrow',
          ga_event_action: 'saved_ads_remove',
          ga_event_label: labelString,
          event: 'ga.event',
        });
        return listingRemoved(button);
      }
      return false;
    }
    return false;
  });
}

function loggedOutSaveButton(button, listingId) {
  const impression = _sr.ecommerce.impressions.find(
    (listing) => listing.id == listingId,
  );
  const labelString = `${impression.id}|${
    impression.brand == 'featured' ? 'f' : impression.position
  }`;
  window.dataLayer.push({
    ga_event_category: 'narrow',
    ga_event_action: 'saved_ads_add_not_logged_in ',
    ga_event_label: labelString,
    event: 'ga.event',
  });
  const { href } = button.dataset;
  return window.location.assign(href);
}

function listingSaved(button) {
  if (button) {
    const { actionNameActive } = button.dataset;
    if (button.classList.contains('button--link')) {
      // get parent for desktop context markup
      const parent = button.closest('.listing-card__save');
      parent.className = 'listing-card__save listing-card__save--saved';
    } else {
      button.classList.remove('button--action');
    }
    const icon = button.querySelector('.button__icon i');
    icon.classList.replace('far', 'fas');
    const text = button.querySelector('.button__text');
    text.textContent = actionNameActive;
    return (button.dataset.href = button.dataset.href.replace(
      'function=add',
      'function=remove',
    ));
  }
  return false;
}

function listingRemoved(button) {
  if (button) {
    const { actionName } = button.dataset;
    // get parent for desktop context markup
    if (button.classList.contains('button--link')) {
      const parent = button.closest('.listing-card__save');
      parent.className = 'listing-card__save listing-card__save--save';
    } else {
      button.classList.add('button--action');
    }
    //
    const icon = button.querySelector('.button__icon i');
    icon.classList.replace('fas', 'far');
    const text = button.querySelector('.button__text');
    text.textContent = actionName;
    return (button.dataset.href = button.dataset.href.replace(
      'function=remove',
      'function=add',
    ));
  }
  return false;
}

function getDuplicateAdButton(button, listingId) {
  const buttons = document.querySelectorAll(
    `.listing-result[data-listing-id="${listingId}"] button.button`,
  );
  const duplicate = [...buttons].filter((btn) => btn !== button);
  return duplicate[0];
}
